import { render, staticRenderFns } from "./ContasReceberLista.vue?vue&type=template&id=6c081c8f&scoped=true&"
import script from "./ContasReceberLista.vue?vue&type=script&lang=js&"
export * from "./ContasReceberLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c081c8f",
  null
  
)

export default component.exports